import { render, staticRenderFns } from "./ShopSliderBackground.vue?vue&type=template&id=2012ac68&scoped=true"
import script from "./ShopSliderBackground.vue?vue&type=script&lang=ts"
export * from "./ShopSliderBackground.vue?vue&type=script&lang=ts"
import style0 from "./ShopSliderBackground.vue?vue&type=style&index=0&id=2012ac68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012ac68",
  null
  
)

export default component.exports